"use client";
import { useRef } from "react";
import QRCode from "react-qr-code";
import { ModalCustom } from "../../../components/custom/modal-custom";
import {
  EQUIPMENT_TYPE_NAME,
} from "../services/equipment-service";
import { EquipmentRow } from "./equipment-table";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data: EquipmentRow | null;
}

const EquipmentQRModal: React.FC<Props> = ({ isOpen, onClose, data }) => {
  const printRef = useRef<HTMLDivElement>(null);

  if (!data) return null;

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    const printWindow = window.open("", "_blank", "width=400,height=500");
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>QR - ${data.code}</title>
          <style>
            body {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
              margin: 0;
              font-family: Arial, sans-serif;
            }
            .qr-container {
              text-align: center;
              padding: 24px;
            }
            .equipment-code {
              font-size: 20px;
              font-weight: bold;
              font-family: monospace;
              margin-bottom: 8px;
            }
            .equipment-name {
              font-size: 14px;
              color: #555;
              margin-bottom: 4px;
            }
            .equipment-type {
              font-size: 12px;
              color: #888;
              margin-bottom: 16px;
            }
            @media print {
              body { margin: 0; }
            }
          </style>
        </head>
        <body>
          <div class="qr-container">
            ${printContent.innerHTML}
          </div>
          <script>
            window.onload = function() { window.print(); window.close(); };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const bodyModal = (
    <div className="flex flex-col items-center py-4">
      <div ref={printRef} className="flex flex-col items-center">
        <p className="text-lg font-bold font-mono mb-1">{data.code}</p>
        {data.name && (
          <p className="text-sm text-gray-600 mb-1">{data.name}</p>
        )}
        <p className="text-xs text-gray-400 mb-4">
          {EQUIPMENT_TYPE_NAME[data.type] || ""}
        </p>
        <div className="bg-white p-4 rounded-lg shadow-sm border">
          <QRCode
            value={data.code}
            size={200}
            bgColor="#ffffff"
            fgColor="#000000"
            level="M"
          />
        </div>
      </div>
      <p className="text-xs text-gray-400 mt-4">
        Quét mã QR để xem thông tin thiết bị
      </p>
    </div>
  );

  const footerModal = (
    <div className="flex gap-2">
      <button
        type="button"
        onClick={handlePrint}
        className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-4 h-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18.25 7.034l-.001-.001"
          />
        </svg>
        In QR
      </button>
      <button
        type="button"
        onClick={onClose}
        className="px-4 py-2 text-sm border rounded hover:bg-gray-50"
      >
        Đóng
      </button>
    </div>
  );

  return (
    <ModalCustom
      titleModal={`Mã QR - ${data.code}`}
      isOpen={isOpen}
      onClose={() => onClose()}
      bodyModal={bodyModal}
      footerModal={footerModal}
      modalSize="sm"
    />
  );
};

export default EquipmentQRModal;
